export interface User {
  username: string;
  password: string;
}

export class UserDetails {
  id: number;
  username: string;
  email: string;
  company: string;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  city: string;
  zip: string;
  state: string;
  country: string;
  resetQuestion: string;
  resetAnswer?: string;
  password?: string;
  emailUpdates: boolean;
}

export interface ModifyUserRequest {
  user: Partial<UserDetails> & { id: number };
  existingPassword: string;
}

export class CustomerInfo {
  company: string;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  city: string;
  zip: string;
  state: string;
  country: string;
}

export class Register {
  username: string;
  password: string;
  email: string;
  resetQuestion: string;
  resetAnswer: string;
  contractNo: number;
  contractPassword: string;
  inviteToken?: string;
}

export interface ContractInviteRequest {
  email: string;
  invitedByEmail?: string;
}

export interface ContractInviteResponse {
  token?: string;
  email: string;
  contractNo: number;
  url: string;
  existingUser: boolean;
  invitedByName?: string;
  invitedByEmail?: string;
  created?: string | Date;
  expires?: string | Date;
  expired?: boolean;
}
